module.exports = __webpack_public_path__ + "static/media/rightArrowSelected.85219317.svg";